(function(angular){
	'use strict';
	
	angular
		.module('ipoModule')
		.controller('IpoController', [
			'$scope',
			'Big',
			'globalConfig',
			'ipoFactory',
			'urlFactory',
			IpoControllerFunction
		]);
	
	function IpoControllerFunction(
		$scope,
		Big,
		globalConfig,
		ipoFactory,
		urlFactory
	){
		var ipo = this;

		ipo.$onInit = function() {
			ipo.numberOfShares = new Big(globalConfig.maxIpoInvestment);
			ipo.pricePerShare = new Big(globalConfig.pricePerShare);
			ipo.totalAmount = ipo.numberOfShares.times(ipo.pricePerShare).toString();
			ipo.maxIpoInvestment = new Big(globalConfig.maxIpoInvestment);
			ipo.minIpoInvestment = new Big(globalConfig.minIpoInvestment);
			ipo.showKpiGrowthSince = '1yr';
			ipo.isEligibleForRepeatCheckout = globalConfig.isEligibleForRepeatCheckout;
			ipo.reitOfferingVintageId = globalConfig.reitOfferingVintageId;
			ipo.disableInvest = false;

			ipoFactory.getKeyPerformanceIndicators()
				.then(function(keyPerformanceIndicatorsTable) {
					ipo.keyPerformanceIndicatorsTable = keyPerformanceIndicatorsTable;
				});
		};

		function invalidAmount() {
			ipo.disableInvest = true;
			ipo.totalAmount = '';
		}

		ipo.handleAmountInput = function(){
			if(ipo.numberOfShares) {
				ipo.numberOfShares = new Big(ipo.numberOfShares);
				if(ipo.numberOfShares.lte(ipo.maxIpoInvestment) && ipo.numberOfShares.gte(ipo.minIpoInvestment)) {
					ipo.disableInvest = false;
					ipo.totalAmount = ipo.numberOfShares.times(ipo.pricePerShare).toString();
				} else {
					invalidAmount();
				}
			} else {
				invalidAmount();
			}
		};

		ipo.openModal = function() {
			$scope.$broadcast('confirmationModal:open');
		};

		ipo.investIPO = function() {
			urlFactory.redirect('/reits/checkout/repeat/start?reitOfferingVintageId=' + ipo.reitOfferingVintageId + "&amount=" + ipo.totalAmount);
		};
	}
})(window.angular);